import LaporanAktivitasHarian from "./LaporanAktivitasHarian";

export default LaporanAktivitasHarian;
